//封装操作localstorage本地存储的方法   模块化的文件


// nodejs  基础


var config={

    // URL:"http://www.bjcdzbh.com/tbbh"
    // URL:"http://ceshi1.diemingcar.com/tbbh/"
    URL:"/tbbh/"
    // URL:"http://dashenxiafan.in.8866.org:44744"

}

export default config;





// WEBPACK FOOTER //
// ./src/model/config.js